import { business, businessId, businesses, token, reset, userLoggedIn, userInfo, notifications, listener, ref, setLoggedInDataWithToken, redirectionId, benefitAssignation, paymentLinkUrl, isPaymentLink } from "./pinia";

export const store = {
  $token: token,
  $businessId: businessId,
  $business: business,
  $businesses: businesses,
  $userLoggedIn: userLoggedIn,
  $userInfo: userInfo,
  $reset: reset,
  $notifications: notifications,
  $listener: listener,
  $ref: ref,
  $setLoggedInDataWithToken: setLoggedInDataWithToken,
  $redirectionId: redirectionId,
  $benefitAssignation: benefitAssignation,
  $paymentLinkUrl: paymentLinkUrl,
  $isPaymentLink: isPaymentLink,
}
